import { useQuery } from "@tanstack/react-query";
import { fetchWadaPatraById } from "../services/wadaPatraServices";

export const useFetchWadaDetails = (id) => useQuery({
    queryKey: ['wadapatra', id],
    queryFn: () => fetchWadaPatraById(id),
    enabled: !!id
})
